import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSidebarRightHide16Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconSidebarRightHide16Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10 3H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h7zm5 1a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2zM4.917 6.234a.5.5 0 1 1 .707-.708l2.121 2.122L8.1 8l-.354.354-2.12 2.121a.5.5 0 1 1-.708-.707L6.686 8z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSidebarRightHide16Filled);
